// extracted by mini-css-extract-plugin
export default {"badgesContainer":"Badges_badgesContainer__25Z8h","badgeManagerButton":"Badges_badgeManagerButton__wlpPV"};